enum PatientProfile {
  YES = 'S',
  MANDATORY = 'J',
  NO = 'N',
}

export { PatientProfile };